import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalenderComponent } from '../tags/calender/calender.component';
import { DropDownComponent } from '../tags/drop-down/drop-down.component';
import { InputFieldComponent } from '../tags/input-field/input-field.component';
import { MultiSelectDropDownComponent } from '../tags/multi-select-drop-down/multi-select-drop-down.component';
import { RangeSliderComponent } from '../tags/range-slider/range-slider.component';
import { PasswordComponent } from '../tags/password/password.component';
import { SearchFilterFieldComponent } from '../tags/search-filter-field/search-filter-field.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-dynamic-form-builder',
    imports: [MultiSelectDropDownComponent, InputFieldComponent, RangeSliderComponent, PasswordComponent, SearchFilterFieldComponent, FormsModule, ReactiveFormsModule, CalenderComponent, DropDownComponent],
    templateUrl: './dynamic-form-builder.component.html',
    styleUrl: './dynamic-form-builder.component.scss'
})
export class DynamicFormBuilderComponent {
@Input() field: any;
  @Input() form: any;
  @Output() datetoEvent = new EventEmitter<string>();

@Output() userEmailSelected = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {

  }
  receiveMessage(message: string) {
     console.log(message, 'sterr 1')
    this.datetoEvent.emit(message);

  }
}
